import { Controller } from "@hotwired/stimulus";
import createEditor from "src/decidim/editor";
export default class extends Controller {
  connect() {
    this.editor = createEditor(this.element);
  }
}
